module.exports = __webpack_public_path__ + "img/vsBronzer2.022dec15.jpg";